import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import router from '@/router'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
export function post(url, params ,BASE2) {
// axios 配置
  var baseurl=BASE2?BASE2:BASE.base1;

  return new Promise((resolve, reject) => {
    // console.log('000',LocalStorage.get('token'))

    axios.defaults.headers.common['token'] = LocalStorage.get("datacollect_token")?LocalStorage.get("datacollect_token"):'';
    // axios.defaults.responseType = ""

    axios
      .post(baseurl + url, params)
      .then(
        response => {
          // console.log(response.data.status)

          if(response.data.status=="444"){
            MessageBox.confirm('登录已过期，请重新登录！', '提示', {
              closeOnClickModal:false,
              showClose:false,
              showCancelButton:false,
              confirmButtonText: '重新登录',
              type: 'warning'
            }).then(() => {

              if(!LocalStorage.get('datacollect_remember')){
                LocalStorage.del('datacollect_remember');
                LocalStorage.del('datacollect_userId');
                LocalStorage.del('datacollect_pwd');
              }
              LocalStorage.del('datacollect_userName');
              LocalStorage.del('datacollect_token');
              store.commit('SET_Menulist', []);
              store.commit('SET_UserButton', []);
              store.commit('SET_temId', '');
              router.replace({
              name: 'login',
            })
            })

          }else {
            var data = response.data
            if (Object.keys(data).length !== 0) {
              resolve(data)
            }
          }
        },
        err => {

          reject(err)

        }
      )
      .catch(error => {
        reject(error)
      })
  })
}
export function get(url,params,BASE2) {
  // console.log(url,params,BASE2)
  var baseurl=BASE2?BASE2:BASE.base1;

  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['token'] = LocalStorage.get("datacollect_token")?LocalStorage.get("datacollect_token"):'';

    axios
      .get(baseurl + url, {
        params: Object.assign(
          params
        )
      })
      .then(
        response => {
          if(response.data.status=="444"){
            MessageBox.confirm('登录已过期，请重新登录！', '提示', {
              closeOnClickModal:false,
              showClose:false,
              showCancelButton:false,
              confirmButtonText: '重新登录',
              type: 'warning'
            }).then(() => {
              router.push({
                name: 'login',
              })
            })

          }else {
            var data = response.data
            if (Object.keys(data).length !== 0) {
              resolve(data)
            }
          }

        },
        err => {
          reject(err)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}






// WEBPACK FOOTER //
// ./src/utils/axios.js